import React from 'react';
import {Link} from 'react-router-dom';
import Button from '@material-ui/core/Button';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';


const NotFound = ()=> {
    return (
        <div id="secret" className="smallRoot">
            <div className="paper">
                <div style={{fontSize:"200%"}}>
                    <FontAwesomeIcon icon="user-lock"/> ページが見つかりません
                </div>
                <div style={{marginTop:"1em",textAlign:"center"}}>
                    このページは存在しません。削除されたのかも。
                </div>
                <div style={{marginTop:"2em",textAlign:"center"}}>
                    <Link to="/" className="link"><Button variant="outlined" color="primary">トップへ</Button></Link>
                </div>

            </div>
        </div>
    );
}

export default NotFound;
